module.exports = new __parcel__URL__("hero.8b784ab9.svg").toString();